import Component from '@bythepixel/component-loader';
import Observer from './Observer';
import config from './config';

export default class StickyContainer extends Component {
  static selector = '[data-comp-sticky-container]';

  constructor(containerEl, options = config) {
    super(containerEl, options);
    this.observable = document.querySelector(options.selectors.observable);

    const observerOptionsJson = containerEl.dataset.compStickyContainerObserverOptions;
    this.observerOptions = observerOptionsJson ? JSON.parse(observerOptionsJson) : null;

    this.mount();
  }

  get isSticking() {
    return this.$container.dataset.compStickyContainerSticking === 'true';
  }

  set isSticking(updatedState) {
    this.$container.dataset.compStickyContainerSticking = updatedState;
  }

  // Not ideal, but works for the current use case of making blog/work index page
  // category selectors sticky: the 100ms setTimeout prevents a rapid bouncing effect
  // when the observer events fire.
  attachObserverListeners() {
    window.addEventListener(
      'sticky-container:in-view',
      () => setTimeout(
        () => this.isSticking = false,
        100,
      ),
    );

    window.addEventListener(
      'sticky-container:out-of-view',
      () => setTimeout(
        () => this.isSticking = true,
        100,
      ),
    );
  }

  mount() {
    this.Observer = new Observer(this.observerOptions);
    this.Observer.observe(this.observable);

    this.attachObserverListeners();
  }
}
